<template>
    <div class="flex gap-2 flex-wrap"  v-click-outside="handleOutsideClick">
                    <span v-for="country in selectedCountries" class="flex gap-1 border border-grey-300 rounded-full p-1 items-center text-grey-900 pr-3">
                        <img :src="'/images/flags/'+country.code+'.svg'" class="size-6 rounded-full" :alt="country.name"> {{country.name}}
                    </span>

        <div class="relative" >
            <a href="" class="flex gap-2 border border-dashed border-grey-300 rounded-full p-0.5 px-1.5 items-center pr-3" @click.prevent.stop="dropdownOpen = !dropdownOpen">
                <i class="far fa-circle-plus text-lg text-grey-500"></i>
                <span class="text-grey-900">{{translate('add')}}</span>
                <i class="far fa-angle-down text-sm text-grey-500"></i>
            </a>

            <div class="absolute p-2 bg-white rounded-lg w-80 shadow-xl z-50 mt-2" v-if="dropdownOpen">
                <ul>
                    <li class="p-2 rounded-md flex justify-between items-center hover:bg-grey-100 cursor-pointer" v-for="country in countries" @click.stop="toggleCountry(country)">
                        <div>
                            <input type="checkbox" :checked="selectedCountries.includes(country)" :disabled="country.code === 'nl'" class="mb-1">
                            <span class="text-md font-medium inline-block ml-1">{{country.name}}</span>
                        </div>
                        <span class="text-grey-700" v-if="country.code !== 'nl'">€ 400 / {{translate('jaar').toLowerCase()}}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {useStore as useCheckoutStore, useStore} from "../store";
import {ISelectCountry} from "../types";

export default defineComponent({
    name: "country-selector",
    data() {
        return {
            store: useStore(),
            dropdownOpen: false
        }
    },
    computed: {
        countries(): ISelectCountry[] {
            return useCheckoutStore().countries;
        },
        selectedCountries(): ISelectCountry[] {
            return useCheckoutStore().selectedCountries;
        },
    },
    methods:{
        toggleCountry(country: ISelectCountry) {
            if(country.code === 'nl')
                return;

            const index = this.selectedCountries.indexOf(country);
            if(index >= 0)
                this.selectedCountries.splice(index, 1)
            else
                this.selectedCountries.push(country);

            this.dropdownOpen = false;
        },
        handleOutsideClick(e: MouseEvent) {
            this.dropdownOpen = false;
        }
    }
})
</script>